import CountDown from './countdown.vue';

function install(Vue) {
    Vue.component(CountDown.name, CountDown);
}
export default {CountDown, install};
export {CountDown, install};



// WEBPACK FOOTER //
// ./src/n_modules/mini-countdown/components/index.js